import './style/index.js';

import _Col from './Col';
import _Row from './Row';

export type { ColProps } from './Col';
export type { RowProps } from './Row';
export * from './type';

export const Row = _Row;
export const Col = _Col;
